<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section">
        <UiContainer max-width="max-w-4xl">
            <div class="py-9 [&>p]:fs-3xl [&>p]:font-eb-garamond [&>p]:mb-8 [&>p>a]:underline [&>blockquote>p]:text-chsc-indigo-500 [&>blockquote>p]:fs-4xl [&>blockquote>p]:mb-8 [&>blockquote>p]:font-londrina-solid">
                <StoryblokRichText :doc="blok?.text" />
            </div>
        </UiContainer>
    </section>
</template>